export default "__VITE_ASSET__DOIbkPW0__"